<script>
	let photos = [
		{ src: 'images/DSCF1081.jpg', alt: 'Photo', title: 'Kiss' },  	
		{ src: 'images/DSCF1088.jpg', alt: 'Photo', title: 'Couple' },  	
		{ src: 'images/DSCF1090.jpg', alt: 'Photo', title: 'Groomsmen' },  
		{ src: 'images/DSCF1123.jpg', alt: 'Photo', title: 'Akaash in Tux' },
	  	{ src: 'images/DSCF1168.jpg', alt: 'Photo', title: 'Plus-ones' }
	  // Add more photos here
	];
  </script>
  <svelte:head>
  <style>
    body {
      background-color: #cccccc;
    }
  </style>
</svelte:head>

  <style>

	.portfolio {
	  display: flex;
	  flex-direction: column;
	  gap: 1rem;
	  padding: 1rem;
	}
  
	.photo {
	  overflow: hidden;
	  position: relative;
	}
  
	.photo img {
	  width: 100%;
	}
  
	 
  
  </style>
  
  <div class="portfolio">
	{#each photos as photo}
	  <div class="photo">
		<img src={photo.src} alt={photo.alt} />
	  </div>
	{/each}
  </div>